import { generateAlternateLinksList } from './generateAlternateLinksList'
import { generateCanonicalLink } from './generateCanonicalLink'

type GeneratePageMetaLinksPayload = {
  noAlternates?: boolean
}

export const generatePageMetaLinks = (payload?: GeneratePageMetaLinksPayload) => {
  return payload?.noAlternates
    ? [generateCanonicalLink()]
    : [
      ...generateAlternateLinksList(),
      generateCanonicalLink(),
    ]
}
